import DepartamentDetailTabTimeline from '@/components/departament/timeline/DetailTabTimeline.vue'

const timelineRouter = (beforeEnter, name, singleName, basePath, tabs) => {
    return {
        beforeEnter: beforeEnter,
        name: `${singleName}DetalheAbaTimeline`,
        path: `${basePath}/detalhe/:id/timeline`,
        meta: {
            requiresAuth: true,
            isEmployee: true,
            layout: 'default',
            basePath,
            singleName,
            tabs
        },
        component: DepartamentDetailTabTimeline
    }
}

export default timelineRouter
